import { RefundItemLIne } from "./refund-item-line";
import * as React from "react";
import { RefundRequest } from "../../../../../application/domain/payment/refund-request";

export const RefundItemTable: React.FC<{
  refundRequest: RefundRequest;
  onChange: (v: RefundRequest) => void;
  confirm?: boolean;
}> = ({ refundRequest, onChange, confirm }) => {
  return (
    <table className="table is-fullwidth c-border">
      <thead>
        <tr>
          <th style={{ width: "40%" }}>費目</th>
          <th className="has-text-right" style={{ width: "25%" }}>
            返金上限
          </th>
          <th className="has-text-right" style={{ width: "35%" }}>
            返金額
          </th>
        </tr>
      </thead>
      <tbody>
        {refundRequest.items.map((v, index) => (
          <RefundItemLIne
            confirm={confirm}
            item={v}
            onChange={(v) => {
              onChange(refundRequest.update(v, index).copy());
            }}
          />
        ))}
      </tbody>
    </table>
  );
};
